export default __webpack_public_path__ + "static/media/camview-thumb-fhd2.dd6cc812.webp";